export enum HubMethods {
    RetrieveCurrentCall = 'retrieveCurrentCall',
    OnRetrieveCurrentCall = 'onRetrieveCurrentCall',
    OnCallState = 'onCallState',
    StartCall = 'startCall',
    WriteCallAudioData = 'writeCallAudioData',
    EndCall = 'endCall',
}
